import React, { ButtonHTMLAttributes } from 'react';
import Button from 'components/Button';

interface DangerButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const DangerButton: React.FC<DangerButtonProps> = ({
  children,
  ...props
}) => {
  return (
    <Button {...props} className="btn btn-danger">
      {children}
    </Button>
  );
};

export default DangerButton;
